// extracted by mini-css-extract-plugin
export default {"main":"MainContent-module__main__obPqz","modern":"MainContent-module__modern__iITlI"};